
import VLazyImage from 'v-lazy-image'
import FacebookSvg from '@/assets/icons/facebook.svg?inline'
import TwitterSvg from '@/assets/icons/twitter.svg?inline'
import YelpSvg from '@/assets/icons/yelp.svg?inline'
import LinkedinSvg from '@/assets/icons/linkedin.svg?inline'

export default {
  name: 'Footer',

  components: {
    VLazyImage,
    FacebookSvg,
    TwitterSvg,
    YelpSvg,
    LinkedinSvg,
  },
}
